/// <reference path="./global_d" />
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

export * from './portal';
export * from './dom-portal-outlet';
export * from './portal-directives';
export * from './portal-injector';
